<div
  [ngClass]="checkJourneyType === 'ONE_WAY' ? 'oneway-dateselection' : ''"
  class="travelDateSelectionView"
>
  <div
    *ngIf="
      checkJourneyType === 'MULTI==========CITY';
      then multicity_content;
      else other_content
    "
  >
    here is ignored
  </div>

  <ng-template #other_content>
    <div [formGroup]="travelDateForm" class="form-group">
      <div class="icon-addon">
        <input
          #calendarDir="ngc-calendar"
          (calBlur)="inputBlurEmit($event)"
          (calClick)="inputClickEmit($event)"
          (calFocus)="inputFocusEmit($event)"
          [allowDay]="allowDay"
          [allowPreviousDay]="allowPreviousDay ? allowPreviousDay : 0"
          [calendarCustomClass]="calendarClass"
          [dataTravel]="travelType === 'Departure' ? 'oneway' : 'roundtrip'"
          [defaultDepartDate]="defaultDepartDate"
          [displayDateFormat]="displayDateFormat ? displayDateFormat : 'mm/dd'"
          [fieldName]="
            travelType === 'Departure' ? 'departureDate' : 'returnDate'
          "
          [formObj]="formObj"
          [formObject]="travelDateForm"
          [index]="index"
          [isFirstElement]="firstElement"
          [ngClass]="{ 'form-control inputText': true }"
          [numberOfMonthsView]="viewportWidth <= 991 ? 12 : 2"
          [showDateFormat]="showDateFormat ? showDateFormat : ''"
          [showDefaultDate]="showDefaultDate ? showDefaultDate : false"
          aria-required="true"
          autocomplete="off"
          calDefaultDateSeparator="false"
          departLabel="{{ departlabelText }}"
          departPlaceHolder="{{ departPlaceHolderText }}"
          floatingLbl="{{ floatingLbl }}"
          id="{{ dateFor }}"
          isFlexDates="{{ isFlexDates }}"
          isFlexDatesDisabled="{{ isFlexDatesDisabled }}"
          isFlexDatesDisabledByEdoc="{{ isFlexDatesDisabledByEdoc }}"
          ngc-calendar
          placeholder=""
          returnLabel="{{ returnlabelText }}"
          returnPlaceHolder="{{ returnPlaceHolderText }}"
          standaloneCal="{{ standaloneCal }}"
          type="text"
          [ariaLabel]="labelText"
        />
      </div>
    </div>
  </ng-template>
  <ng-template #multicity_content></ng-template>
</div>
